import { render, staticRenderFns } from "./siteAdminGroupList.vue?vue&type=template&id=209a7d3c&scoped=true&"
import script from "./siteAdminGroupList.vue?vue&type=script&lang=js&"
export * from "./siteAdminGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a7d3c",
  null
  
)

export default component.exports